<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item>
                <router-link to="/EodbReport">
                  EODB Report
                </router-link>
              </b-breadcrumb-item>
                 <b-breadcrumb-item href="#" active>EODB Third-Party Consumer Verification</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">EODB Third-Party Consumer Verification</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
            <b-row>
                <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 7px;">
                        <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="12" sm="12" md="3" lg="3" style="padding-top: 5px;">
                    <b-form-input type="number" maxlength="12" id="consNo" value=""  placeholder="Enter your Consumer Number" trim required />
                </b-col>
                <b-col col cols="5" sm="5" md="3" lg="2" style="padding-top: 5px;" >
                  <img id="captcha" src="#" alt="captcha">
                  <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px">
                  </b-icon></a>
                </b-col>
                <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                    <b-form-input type="number" id="result" placeholder="Answer" style="padding-top: 7px;" />
                </b-col> 
                <b-col col cols="4" sm="4" md="3" lg="1" style="padding-top: 5px;">
                        <b-button @click="checkConsumer()" block pill variant="primary" size="md" class="go" style="width:100%">
                        <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                        </b-button>

                </b-col>
            </b-row>
            <br />
            <b-row v-if="consumerStatus">
                <b-col cols="12" class="mt-2" style="text-align:center">
                    <b-alert :variant="consumerStatus === 'valid' ? 'success' : 'danger'" show>
                        The consumer number is {{ consumerStatus }}.
                    </b-alert>
                </b-col>
            </b-row>
        </div>
       </b-container>

    <br><br>
    </b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile

  },

  data() {
    return {

      show:false,
    //   consNo: '',
      consumerStatus: ''
    }
  },
  methods: {
      generateCaptcha()
      {
        axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                  // console.log("captchaImage:::"+response.data);
                  document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

      })
      },
      checkConsumer(){
        // console.log("inside function");
        var consNo = document.getElementById("consNo").value;

        if ((consNo.toString().length!=12)) {
            this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
                title: `Alert`,
                variant: 'danger',
                solid: true
            });
            return;
        }
        var result = document.getElementById("result").value;
        if ((result==""))
        {
          this.$bvToast.toast('Enter Captcha !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }  

        this.consNo = consNo;
        this.show = true;
        var parent = this;
        const requestData = {
            consNo: this.consNo
        };
        // console.log("requestData:::"+JSON.stringify(requestData));
        
        axios.post(parent.$urlCommon+"/api/web/eodbConsValidity?result="+result, requestData, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
        .then((response) => {
            parent.show= false;
            // console.log("response data:::::"+JSON.stringify(response.data));

            if(response.data.isValid == "N"){
                parent.consumerStatus = "not valid";
            }
            else if(response.data.isValid == "captcha_incorrect"){
              parent.$bvToast.toast('Invalid Captcha ! Please try again', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                });
                document.getElementById("BillDetails").classList.remove("showBillDetails");
                document.getElementById("result").value="";
                document.getElementById("result").focus();
                return;
            }
            else if(response.data.isValid == "Y"){
                parent.consumerStatus = "valid";
            }
            else{
              parent.$bvToast.toast('Error!!', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                });
            }
            parent.generateCaptcha();
        })
        .catch(error => {
            console.error('Error:', error);
            parent.generateCaptcha();
        });
      }

  },
  mounted() {
    axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
      document.getElementById("captcha").src= "data:image/png;base64,"+response.data;
    })
  }
}
</script>

<style scoped="true">

/deep/ .table > tbody > tr > td {
font-size: 1.2rem;
  font-weight: 600;
  color: #dd2c00  ;
}
.title {
  color: #1976d2;
  font-size: 1.5rem;
  font-weight: 600;
  text-transform: none !important;
}
.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
